// web/src/screens/MyOrdersScreen.jsx
import { useState, useEffect } from 'react';
import { useNav, useAuth } from '../App';
import { Tickets } from '../db';
import { apiClient } from '../api';

export default function MyOrdersScreen() {
  const { navigate }          = useNav();
  const { user }              = useAuth();
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { loadActiveTickets(); }, []);

  const loadActiveTickets = async () => {
    setLoading(true);
    try {
      const { data } = await apiClient.get('/tickets/active');
      const mine = user?.role === 'waiter'
        ? data.filter(t => t.waiter_id === user.sub)
        : data;
      setTickets(mine);
    } catch {
      const local = await Tickets.getActive();
      setTickets(local);
    } finally {
      setLoading(false);
    }
  };

  const elapsed = (openedAt) => {
    const mins = Math.floor((Date.now() - new Date(openedAt)) / 60000);
    if (mins < 60) return `${mins}m`;
    return `${Math.floor(mins / 60)}h ${mins % 60}m`;
  };

  return (
    <div style={s.container}>
      <div style={s.header}>
        <button style={s.backBtn} onClick={() => navigate('tables')}>← TABLES</button>
        <span style={s.title}>MY ORDERS</span>
        <button style={{ ...s.backBtn, color: 'var(--text-muted)' }} onClick={loadActiveTickets}>↻ REFRESH</button>
      </div>

      {loading && <p style={s.empty}>Loading...</p>}
      {!loading && tickets.length === 0 && (
        <p style={s.empty}>No active orders right now</p>
      )}

      <div style={s.list}>
        {tickets.map(ticket => (
          <div key={ticket.id} style={s.card}>
            <div style={s.cardHeader}>
              <span style={s.cardTable}>{ticket.table_name}</span>
              <span style={s.cardTime}>⏱ {elapsed(ticket.opened_at)}</span>
            </div>

            <div style={s.cardMeta}>
              <span style={s.cardItems}>
                {(ticket.lines || []).slice(0, 3).map(l => `${l.qty}× ${l.name}`).join(', ')}
                {(ticket.lines || []).length > 3 ? ` +${(ticket.lines || []).length - 3} more` : ''}
              </span>
              <span style={s.cardTotal}>KES {Number(ticket.total).toLocaleString()}</span>
            </div>

            <div style={s.cardStatus}>
              <span style={{
                ...s.statusBadge,
                ...(ticket.status === 'sent'
                  ? { background: 'var(--table-active)', color: '#fff' }
                  : ticket.status === 'ready'
                  ? { background: 'var(--table-free)', color: '#fff' }
                  : { background: 'var(--surface-2)', color: 'var(--text)' }),
              }}>
                {(ticket.status || 'open').toUpperCase()}
              </span>
              <span style={{ color: 'var(--text-muted)', fontSize: 12 }}>
                Waiter: {ticket.waiter_name}
              </span>
            </div>

            <div style={s.cardActions}>
              <button style={s.viewBtn} onClick={() =>
                navigate('order', {
                  table: { id: ticket.table_id, name: ticket.table_name },
                  ticketId: ticket.id,
                })
              }>
                VIEW / ADD ITEMS
              </button>
              <button style={s.billBtn} onClick={() =>
                navigate('cart', {
                  table:    { id: ticket.table_id, name: ticket.table_name },
                  ticketId: ticket.id,
                  lines:    ticket.lines || [],
                  total:    ticket.total,
                })
              }>
                REQUEST BILL
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const s = {
  container:   { backgroundColor:'var(--bg)', minHeight:'100vh', color:'var(--text)', fontFamily:"'Barlow Condensed',sans-serif" },
  header:      { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 16px', borderBottom:'1px solid var(--border)' },
  backBtn:     { background:'none', border:'none', color:'var(--orange)', fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:'inherit' },
  title:       { fontSize:18, fontWeight:700, letterSpacing:2 },
  empty:       { color:'var(--text-muted)', textAlign:'center', padding:40, fontSize:15 },
  list:        { padding:12 },
  card:        { background:'var(--surface)', borderRadius:8, padding:16, marginBottom:12 },
  cardHeader:  { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 },
  cardTable:   { color:'var(--orange)', fontSize:20, fontWeight:700 },
  cardTime:    { color:'var(--text-muted)', fontSize:13 },
  cardMeta:    { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:8 },
  cardItems:   { color:'var(--text-muted)', fontSize:13, flex:1, marginRight:12, lineHeight:1.4 },
  cardTotal:   { color:'var(--text)', fontSize:18, fontWeight:700, flexShrink:0 },
  cardStatus:  { display:'flex', alignItems:'center', gap:12, marginBottom:12 },
  statusBadge: { padding:'3px 10px', borderRadius:4, fontSize:11, fontWeight:700, letterSpacing:1 },
  cardActions: { display:'flex', gap:8 },
  viewBtn:     { flex:1, padding:'10px 0', background:'var(--surface-2)', border:'none', borderRadius:6, color:'var(--text)', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'inherit' },
  billBtn:     { flex:1, padding:'10px 0', background:'var(--table-bill)', border:'none', borderRadius:6, color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'inherit' },
};
